import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PutterLevel } from '../../api/models';

export type TABLE_TYPE = Table<PutterLevel>;

export const TABLE = 'putterLevel';
const SCHEMA = 'putterLevelId, sortId';

class PutterLevelDatabase implements DataRepository<PutterLevel> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PutterLevel | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PutterLevel, key: Key): Promise<PutterLevel> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PutterLevel[]): Promise<PutterLevel[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PutterLevel[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PutterLevelDB = new PutterLevelDatabase(db);
